export interface IDeleteResponse {
    n: number;
    ok: number;
    deletedCount: number;
}
